<template>
    <div :class="classObj" class="app-wrapper" id="container">
      <el-container>
        <el-aside width="auto" v-if="navigationMode === 'leftVertical'">
          <div v-if="device === 'mobile' && !isCollapse" class="drawer-bg" @click="handleClickOutside" />
          <common-menu-aside v-if="device !== 'mobile'" />
          <common-menu-aside class="drawer-container" :class="{ showMenu: !isCollapse }" v-if="device === 'mobile'" />
          <!-- <common-menu-aside/> -->
        </el-aside>
        <el-container class="main-container">
          <el-header height="64px">
            <common-header />
          </el-header>
          <div class="tags-view" v-if="multiTabShow">
            <tags-view/>
          </div>
          <el-main :style="{'background-color': BackgroundColor} ">
            <transition :name="switchAnimation ? switchMode : ''" mode="out-in">
              <keep-alive include="cachedViews">
                <router-view :key="key"></router-view>
              </keep-alive>
            </transition>
          </el-main>
          <!-- <el-footer>
            <common-footer />
          </el-footer> -->
        </el-container>
      </el-container>
    </div>
  </template>
  
  <script>
  import CommonMenuAside from "./components/menu/CommonMenuAside.vue";
  import CommonHeader from "./components/header/CommonHeader.vue";
  import CommonFooter from "./components/footer/CommonFooter.vue";
  import TagsView from './components/TabsView/index.vue'
  import ResizeMixin from './mixin/ResizeHandler'
  export default {
    data() {
      return {
        opened: false,
        BackgroundColor: '#fff',
      };
    },
    mixins: [ResizeMixin],
    computed: {
      isCollapse() {
        return this.$store.state.tab.isCollapse
      },
      device() {
        return this.$store.state.tab.device
      },
      classObj() {
        return {
          hideSidebar: !this.opened,
          openSidebar: this.opened,
          withoutAnimation: this.isCollapse,
          mobile: this.device === 'mobile'
        }
      },
      switchAnimation() {
        return this.$store.state.settings.switchAnimation;
      },
      switchMode() {
        return this.$store.state.settings.switchMode;
      },
      multiTabShow() {
        return this.$store.state.settings.multiTabShow;
      },
      cachedViews() {
        return this.$store.state.tagsView.cachedViews
      },
      key() {
        if(this.$route.path.indexOf('/member/details') == 0){
          this.BackgroundColor = 'transparent'
        }else{
          this.BackgroundColor = '#fff'
        }
        
        return this.$route.path
      },
      // 导航栏模式 
      navigationMode() {
        return this.$store.state.settings.navigationMode;
      },
    },
    methods: {
      handleClickOutside() {
        this.$store.dispatch('updateCollapseMenu', true)
      }
    },
    components: {
      CommonMenuAside,
      CommonHeader,
      CommonFooter,
      TagsView,
    },
  };
  </script>
  
  <style lang="scss" scoped>
  @import "~@/assets/styles/mixin.scss";
  @import "~@/assets/styles/variables.scss";
  
  .app-wrapper {
    @include clearfix;
    position: relative;
    height: 100%;
    width: 100%;
  
    &.mobile.openSidebar {
      position: fixed;
      top: 0;
    }
  }
  
  #container {
    background-color: #f4f4f4;
  }
  
  .el-header {
    padding: 0;
  }
  
  .el-footer {
    padding: 0;
  }
  
  .tags-view{
    margin-top: 10px;
  }
  
  .el-main {
    margin: 10px 0 0;
    border-radius: 20px;
    background-color: #fff;
  }
  
  .drawer-bg {
    background: #000;
    opacity: 0.3;
    width: 100%;
    top: 0;
    height: 100%;
    position: absolute;
    z-index: 999;
  }
  
  .fixed-header {
    position: fixed;
    top: 0;
    right: 0;
    z-index: 9;
    width: calc(100% - #{$sideBarWidth});
    transition: width 0.28s;
  }
  
  .hideSidebar .fixed-header {
    width: calc(100% - 54px)
  }
  
  .mobile .fixed-header {
    width: 100%;
  }
  
  .main-container {
    height: 100vh;
    padding: 0 10px 10px;
  }
  
  .drawer-container {
    // width: 0;
    top: 0;
    left: -64px;
    height: 100%;
    position: absolute;
    z-index: 999;
    transition: all 0.5s;
  }
  
  .showMenu {
    left: 0;
  }
  </style>
  